"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_modules_detail_modal_1 = require("@saatva-bits/pattern-library.modules.detail-modal");
const pattern_library_modules_selection_1 = require("@saatva-bits/pattern-library.modules.selection");
const pattern_library_modules_promotions_1 = require("@saatva-bits/pattern-library.modules.promotions");
const product_1 = require("./utils/product");
const analytics_1 = require("./utils/analytics");
const Gallery_1 = __importDefault(require("./partials/Gallery"));
const ProductSummary_1 = __importDefault(require("./partials/ProductSummary"));
const config_1 = require("./utils/config");
const modal_context_1 = require("./store/modal-context");
const pattern_library_modules_cart_1 = require("@saatva-bits/pattern-library.modules.cart");
const pattern_library_components_accordion_set_1 = require("@saatva-bits/pattern-library.components.accordion-set");
const pattern_library_components_accordion_1 = require("@saatva-bits/pattern-library.components.accordion");
const pattern_library_components_button_1 = require("@saatva-bits/pattern-library.components.button");
const pattern_library_components_loader_1 = require("@saatva-bits/pattern-library.components.loader");
const product_detail_modal_module_scss_1 = __importDefault(require("./product-detail-modal.module.scss"));
const ProductDetailModal = ({ onAddToCart = async () => { }, onUpddateItem = async () => { }, onConfigureItem = async () => { }, services = {
    pushRecoStripModalAtcClick: analytics_1.pushRecoStripModalAtcClick
} }) => {
    var _a;
    const { isOpen, setIsOpen, modalAction, setModalAction, isCartItem, selectedProduct, setSelectedProduct, imgixUrl, detailModalProductData: { catalogData, contentData } } = (0, modal_context_1.useProductDetailModal)();
    const { cart } = (0, pattern_library_modules_cart_1.useSharedCartService)();
    const { pushRecoStripModalAtcClick } = services;
    const { productData: selectionContextData } = (0, pattern_library_modules_selection_1.useSelectionStore)();
    const productState = (0, pattern_library_modules_selection_1.useProductState)(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productCode);
    const updateProductAttributes = (0, pattern_library_modules_selection_1.useUpdateProductAttributes)();
    const addProduct = (0, pattern_library_modules_selection_1.useAddProducts)();
    const [noTransitionClass, setNoTransitionClass] = (0, react_1.useState)(true);
    const getProductInfo = async (productCode) => {
        try {
            const productCatalogData = catalogData === null || catalogData === void 0 ? void 0 : catalogData.find((p) => p.productCode === productCode);
            const productContentData = contentData === null || contentData === void 0 ? void 0 : contentData.find((p) => p.sku === productCode);
            if (!productCatalogData) {
                throw new Error('Product or product content data not found');
            }
            // Prevents the modal from crashing in case the content for the product cannot be found
            // The most basic product data will be shown in the modal
            if (!productContentData) {
                console.error(`Product content data not found for product code: ${productCode}`);
            }
            const content = (0, product_1.formatProductContent)(productContentData, selectedProduct, productCatalogData);
            const detailKeysToPick = ['features'];
            const formattedProduct = (0, product_1.formatProduct)(productCatalogData, content, detailKeysToPick, selectedProduct);
            // This adds the product to the selection context so that the detail modal can use the latest selection.
            addProduct([formattedProduct]);
        }
        catch (error) {
            console.error(`Error getting product data: ${error}`);
        }
    };
    /**
     * Get product data from selection context
     */
    const productData = (0, react_1.useMemo)(() => {
        if (!!selectedProduct && !!selectionContextData) {
            return selectionContextData[selectedProduct.productCode];
        }
    }, [selectedProduct, selectionContextData]);
    /**
     * Get variant attribute data to use in default selections of the detail modal
     * only for Cart Items
     */
    const variantAttributes = (0, react_1.useMemo)(() => {
        if (!!selectedProduct && !!productData) {
            return (0, product_1.getVariantAttributes)(selectedProduct, productData);
        }
    }, [selectedProduct, productData]);
    /**
     * Get the ardad gallery or carousel asset descriptors for the product
     */
    const galleryAssetDescriptors = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!!selectedProduct && !!productData) {
            return (_b = (_a = productData === null || productData === void 0 ? void 0 : productData.ardadDescriptors) === null || _a === void 0 ? void 0 : _a.find(descriptor => descriptor.slot === 'carousel')) === null || _b === void 0 ? void 0 : _b.descriptors;
        }
    }, [selectedProduct, productData]);
    (0, react_1.useEffect)(() => {
        if (selectedProduct && !productData && isOpen && catalogData.length > 0 && contentData) {
            getProductInfo(selectedProduct.productCode);
        }
    }, [selectedProduct, productData, isOpen, catalogData, contentData]);
    /**
     * Update modal state
     */
    (0, react_1.useEffect)(() => {
        /**
         * Set selectedProduct as default selection in detail-modal
         * only for Cart Items
         */
        const setDefaultSelection = () => {
            if (variantAttributes) {
                updateProductAttributes(selectedProduct.productCode, {
                    ...variantAttributes,
                    quantity: String(selectedProduct.quantity || 1)
                });
            }
        };
        if (productData && isOpen) {
            setDefaultSelection();
        }
    }, [productData, isOpen, selectedProduct]);
    const productTag = productData && (0, pattern_library_modules_detail_modal_1.handleTag)(productData.isNew, productData.tag);
    const promotionDeps = { useGetDiscounts: pattern_library_modules_promotions_1.useGetDiscounts };
    const selectionDeps = {
        useProductData: pattern_library_modules_selection_1.useProductData,
        useProductState: pattern_library_modules_selection_1.useProductState,
        useAttributeOptions: pattern_library_modules_selection_1.useAttributeOptions
    };
    const customOptionProps = {
        bathSet: {
            toggleProps: {
                modifyOptionLabel: (label) => {
                    return label.replace('Bath', `\nBath`);
                },
                autoFitColumnLayoutOverride: true
            }
        },
        size: { displayType: 'toggle' }
    };
    const hiddenAttributes = ['quantity'];
    const buystack = (0, react_1.useMemo)(() => {
        if (productData && isOpen) {
            return ((0, jsx_runtime_1.jsx)(pattern_library_modules_selection_1.ProductSelectors, { className: product_detail_modal_module_scss_1.default.detailModalSelectors, productCode: productData.productCode, customOptionProps: customOptionProps, shortDropdowns: true, hiddenAttributes: hiddenAttributes }));
        }
    }, [isOpen, productData, customOptionProps, hiddenAttributes]);
    /**
     * Handle user selection
     */
    const addOrUpdateProductsToCart = async () => {
        var _a;
        try {
            const newProduct = {
                ...productState,
                bundleOptions: productState.magentoBundleOptions || null
            };
            // Edit cart item
            if (modalAction === config_1.modalActions.EDIT) {
                modalCloseHandler();
                const qtyDifference = selectedProduct.quantity - newProduct.quantity;
                const originalQty = selectedProduct.originalQuantity || selectedProduct.quantity;
                const newQty = originalQty - qtyDifference;
                await onConfigureItem({
                    itemId: selectedProduct.id,
                    newProduct: newProduct,
                    newItemSku: newProduct.sku,
                    newProduct,
                    newProductQuantity: Number(newProduct.quantity),
                    quantity: Number(newQty),
                    productBeingUpdated: selectedProduct
                });
            }
            // Add Recommended products
            if (modalAction === config_1.modalActions.ADD) {
                const itemInCart = (_a = cart === null || cart === void 0 ? void 0 : cart.items) === null || _a === void 0 ? void 0 : _a.find((cartItem) => cartItem.sku === newProduct.sku);
                modalCloseHandler();
                if (itemInCart) {
                    await onUpddateItem(itemInCart, parseInt(itemInCart.quantity) + parseInt(newProduct.quantity), 'configureItem');
                }
                else {
                    await onAddToCart([
                        {
                            sku: newProduct.sku,
                            quantity: Number(newProduct.quantity),
                            bundleOptions: newProduct.bundleOptions,
                            name: newProduct.genericName || newProduct.name,
                            category: newProduct.category,
                            subcategory: newProduct.subcategory,
                            price: newProduct.price,
                            attributes: newProduct.attributes || newProduct.productAttributes
                        }
                    ], null, 'cart recommended products');
                    pushRecoStripModalAtcClick(newProduct, selectedProduct.productListPosition);
                }
            }
        }
        catch (error) {
            console.error(`Error adding or updating product to cart: ${error}`);
        }
    };
    const quantityAttribute = productData && productData.options.quantity;
    const inStock = productState && productState.inStock;
    const ctaLabel = (0, react_1.useMemo)(() => {
        if (!inStock) {
            return 'Out of stock';
        }
        if (isCartItem) {
            return 'Update cart';
        }
        return 'Add to cart';
    }, [isCartItem, inStock]);
    // Render "Add to Cart button" and Quantity Selector
    const addToCartSection = (0, react_1.useMemo)(() => {
        if (productData) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: product_detail_modal_module_scss_1.default.buttonsWrapper, children: [quantityAttribute && ((0, jsx_runtime_1.jsx)(pattern_library_modules_selection_1.QuantitySelector, { className: product_detail_modal_module_scss_1.default.qtySelector, productCode: selectedProduct.productCode, dataSelector: "QtySelector", maxQuantityOverride: quantityAttribute.values.length })), (0, jsx_runtime_1.jsx)(pattern_library_components_button_1.Button, { disabled: !inStock, onClick: addOrUpdateProductsToCart, className: product_detail_modal_module_scss_1.default.button, kind: "primary", "data-selector": "NewRecoDetail_add-to-cart", children: ctaLabel })] }));
        }
    }, [quantityAttribute, inStock, ctaLabel, selectedProduct, productData, addOrUpdateProductsToCart]);
    const isBeddingCategory = productData && (0, product_1.toLowerCase)(productData.category) === 'bedding';
    const hasquickviewSections = productData && productData.quickviewSections;
    const quickViewSections = (hasquickviewSections &&
        (
        /**
         * TODO: Make this filter configurable to include other sections.
         * This way other teams could use this modal.
         */
        (_a = productData.quickviewSections) === null || _a === void 0 ? void 0 : _a.filter((section) => {
            if (!(section === null || section === void 0 ? void 0 : section.name) || !(section === null || section === void 0 ? void 0 : section.content)) {
                return false;
            }
            if (isCartItem) {
                return (0, product_1.toLowerCase)(section.name) === 'features & benefits';
            }
            return true;
        }))) ||
        [];
    const accordionData = quickViewSections.map((section, index) => ({
        id: section.name,
        title: section.name,
        content: ((0, jsx_runtime_1.jsx)("div", { className: product_detail_modal_module_scss_1.default.accordionContent, dangerouslySetInnerHTML: { __html: section.content } })),
        isOpenOnRender: isBeddingCategory ? index === 0 : true,
        dataSelector: `${(0, product_1.toLowerCase)(section.name.replace(/\s+/g, ''))}-accordion`
    }));
    const accordionTransitionClasses = (0, classnames_1.default)({
        [product_detail_modal_module_scss_1.default.accordionNoTransition]: noTransitionClass
    });
    const accordionClickHandler = () => {
        if (noTransitionClass) {
            setNoTransitionClass(false);
        }
    };
    const modalCloseHandler = () => {
        setSelectedProduct(null);
        setIsOpen(false);
        setIsOpen(false);
        setNoTransitionClass(true);
        setModalAction(config_1.modalActions.ADD);
    };
    return ((0, jsx_runtime_1.jsx)(pattern_library_modules_detail_modal_1.ModalBase, { type: "popup", isOpen: isOpen, closeHandler: modalCloseHandler, modalClasses: product_detail_modal_module_scss_1.default.modal, closeButtonClasses: product_detail_modal_module_scss_1.default.closeButton, contentClasses: product_detail_modal_module_scss_1.default.modalBaseContainer, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [productData && ((0, jsx_runtime_1.jsx)(pattern_library_modules_detail_modal_1.ModalContent, { classes: product_detail_modal_module_scss_1.default.modalContent, mainClasses: product_detail_modal_module_scss_1.default.mainClasses, contentClasses: product_detail_modal_module_scss_1.default.contentClasses, main: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Gallery_1.default, { IMGIX_URL: imgixUrl, selectionDeps: selectionDeps, productCode: productData.productCode, productTag: productTag, galleryAssetDescriptors: galleryAssetDescriptors, altTag: productData.title }) }), content: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProductSummary_1.default, { promotionDeps: promotionDeps, selectionDeps: selectionDeps, title: productData.title, subtitle: productData.subtitle, product: { ...productData }, selectedSizes: productData.selectedSizes }), buystack, (0, jsx_runtime_1.jsx)(pattern_library_components_accordion_set_1.AccordionSet, { accordionData: accordionData, onAccordionItemClick: accordionClickHandler, children: (0, jsx_runtime_1.jsx)(pattern_library_components_accordion_1.Accordion, { className: product_detail_modal_module_scss_1.default.accordion, contentContainerClassName: product_detail_modal_module_scss_1.default.accordionContentContainer, contentClassName: accordionTransitionClasses, classNameModifier: "bgContrastWhite", titleContainerClassName: "t-color", titleClassName: product_detail_modal_module_scss_1.default.accordionTitle, iconClassName: product_detail_modal_module_scss_1.default.accordionIcon, allowMultiOpen: true }) }), addToCartSection] }) })), !productData && isOpen && (0, jsx_runtime_1.jsx)(pattern_library_components_loader_1.Loader, { loaderItemCount: 5, size: "xs" })] }) }));
};
ProductDetailModal.propTypes = {
    /** Callback for adding to cart */
    onAddToCart: prop_types_1.default.func,
    /** Callback for updating cart item */
    onUpddateItem: prop_types_1.default.func,
    /** Callback for configuring cart item */
    onConfigureItem: prop_types_1.default.func,
    /** Services */
    services: prop_types_1.default.shape({
        // Callback for pushing analytics event
        pushRecoStripModalAtcClick: prop_types_1.default.func
    })
};
exports.default = ProductDetailModal;
//# sourceMappingURL=product-detail-modal.js.map